export default {
      id: "radiant-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#radiant",
      toString: function () {
        return this.url;
      }
    }